<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="toc">
<h1 class="toc"><a id="page6"></a>Contents</h1>
<p class="toc_sec"><a class="hlink" href="#/Text/9781454711018_fm1">The Shetland Islands: A Unique History</a></p>
<p class="toc_sec"><a class="hlink" href="#/Text/9781454711018_fm2">Shetland Lace: A Mystery Steeped in Tradition</a></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_fm3" title="Link target outside of Sample">Shetland Lace: Tools &amp; Techniques</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_fm4" title="Link target outside of Sample">How to Use This Book</span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454711018_c01" title="Link target outside of Sample"><span class="toc">Acre &amp; Razor</span></span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s01" title="Link target outside of Sample">Forro Wristers</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s02" title="Link target outside of Sample">Ayre Wristers</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s03" title="Link target outside of Sample">Baetin Wrap</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s04" title="Link target outside of Sample">Almark Shrug</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s05" title="Link target outside of Sample">Aer Cardigan</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c01#s06" title="Link target outside of Sample">Smooriken Pullover</span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454711018_c02" title="Link target outside of Sample"><span class="toc">Old Shale and Feather &amp; Fan</span></span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s07" title="Link target outside of Sample">Tirrick Wristers</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s08" title="Link target outside of Sample">Laebrack Ascot</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s09" title="Link target outside of Sample">Lerwick Vest</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s10" title="Link target outside of Sample">Peerie Blanket</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s11" title="Link target outside of Sample">Brae Yoke Pullover</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c02#s12" title="Link target outside of Sample">Twaafald Tunics</span></p>
<p class="toc_chap"><a id="page7"></a><span class="hlink" href="#/Text/9781454711018_c03" title="Link target outside of Sample"><span class="toc">Horseshoe &amp; Leaf</span></span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s13" title="Link target outside of Sample">Staig Scarf</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s14" title="Link target outside of Sample">Kergord Wristers</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s15" title="Link target outside of Sample">Weisdale Cardigan</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s16" title="Link target outside of Sample">Fyanna Jacket</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s17" title="Link target outside of Sample">Divvish Stole</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s18" title="Link target outside of Sample">Rimska Sweater</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_c03#s19" title="Link target outside of Sample">Tae Shawl</span></p>
<p class="toc_sec1"><span class="hlink" href="#/Text/9781454711018_ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_bm1" title="Link target outside of Sample">Knitting Abbreviations</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_bm2" title="Link target outside of Sample">Yarn Weights</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_bm3" title="Link target outside of Sample">Knitting Needle Size Chart</span></p>
<p class="toc_sec"><span class="hlink" href="#/Text/9781454711018_ata" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454711018_toc.vue?8a961608